import { downloadFile } from "@/packages/orion/helpers";

export const exportAssignedMaterials = async () => {
  return downloadFile("v1/GreenCenters/materials/export", {
    defaultFileName: "asignacion-materiales.xlsx",
    configRequest: {
      headers: { "X-ExcelFormat": "xlsx" },
    },
  });
};
